import { motion } from "framer-motion";
import { useState } from "react";
import {
  
  FiBell,
  FiChevronLeft,
  FiChevronRight,
  FiFile,
  FiCamera,
  FiTrendingUp,
 
} from "react-icons/fi";

const CollapseCardFeatures = () => {
  const [position, setPosition] = useState(0);

  const shiftLeft = () => {
    if (position > 0) {
      setPosition((pv) => pv - 1);
    }
  };

  const shiftRight = () => {
    if (position < features.length - 1) {
      setPosition((pv) => pv + 1);
    }
  };

  return (
    <section className="overflow-hidden bg-neutral-100 px-4 py-12">
      <div className="mx-auto max-w-6xl">
        <div className="mb-8 flex justify-between gap-4">
          <h2 className="text-2xl font-bold leading-[1.2] md:text-5xl">
            We're good. <span className="text-neutral-400">Here's why.</span>
          </h2>
          <div className="flex gap-2">
            <button
              className="h-[60px] md:h-fit bg-black p-4 text-2xl text-white transition-colors hover:bg-neutral-700"
              onClick={shiftLeft}
            >
              <FiChevronLeft />
            </button>
            <button
              className="h-[60px] md:h-fit bg-black p-4 text-2xl text-white transition-colors hover:bg-neutral-700"
              onClick={shiftRight}
            >
              <FiChevronRight />
            </button>
          </div>
        </div>
        <div className="flex gap-4">
          {features.map((feat, index) => (
            <Feature {...feat} key={index} position={position} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

const Feature = ({ position, index, title, description, Icon }) => {
  const translateAmt =
    position >= index ? index * 100 : index * 100 - 100 * (index - position);

  return (
    <motion.div
      animate={{ x: `${-translateAmt}%` }}
      transition={{
        ease: "easeInOut",
        duration: 0.35,
      }}
      className={`relative flex min-h-[250px] w-10/12 max-w-lg shrink-0 flex-col justify-between overflow-hidden p-8 shadow-lg md:w-3/5 ${
        index % 2 ? "bg-black text-white" : " bg-white"
      }`}
    >
    
      <h3 className="mb-8 text-3xl font-bold text-center">{title}</h3>
      <p>{description}</p>
    </motion.div>
  );
};

export default CollapseCardFeatures;

const features = [
  {
    title: "Comprehensive Credit Monitoring",
    Icon: FiCamera,
    description:
      "Stay informed with real-time updates on your business credit across major agencies.",
  },
  {
    title: "Actionable Insights",
    Icon: FiTrendingUp,
    description:
      "Receive personalized recommendations to improve your creditworthiness.",
  },
  {
    title: "Instant Alerts",
    Icon: FiBell,
    description:
      "Get immediate notifications of any changes to your credit profile.",
  },
  {
    title: "Exclusive Full Reports",
    Icon: FiFile,
    description:
     "Access unaltered PDF credit reports, a feature unique to FuteurAI.",
  },
];

